module.exports = __webpack_public_path__ + "img/c04_unittechcoinage_Normal_ua.27b5787c.webp";